import { FC, useEffect } from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getSurveySection } from "app/features/surveySlice";
import { FormControlModel } from "types";
import { ElementType } from "lib/enums/enums";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import StepContent from "../StepContent";
import { useSection } from "lib/context/section";

type Props = {
  formik?: any;
  disabled?: boolean;
  lastSectionId: number | string;
  setIdentificationNumber: (identificationNumber: string) => void;
};

const Step1: FC<Props> = ({ formik, disabled, lastSectionId, setIdentificationNumber }) => {
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};
  const dispatch = useAppDispatch();
  const lastSectionIdNumber = Number(lastSectionId) + 1;
  const { sectionId, setSectionId } = useSection();

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const handleLastSection = (event: any) => {
    event.preventDefault();
    setSectionId(lastSectionIdNumber);
  };

  const dataModel: FormControlModel[] = [
    {
      key: 0,
      formik,
      disabled,
      visible: true,
      label: "Tipo de documento",
      name: "identificationType",
      elementType: ElementType.Select,
      questionData: questions[0] || [],
    },
    {
      key: 1,
      formik,
      disabled,
      visible: true,
      questionData: questions[1],
      label: "Número de documento",
      name: "identificationNumber",
      elementType: ElementType.Textfield,
      onBlurCallback: setIdentificationNumber,
    },
    {
      key: 2,
      formik,
      disabled,
      name: "name",
      visible: true,
      label: "Nombre",
      questionData: questions[2],
      elementType: ElementType.Textfield,
    },
    {
      key: 3,
      formik,
      disabled,
      visible: true,
      name: "lastName",
      label: "Apellido",
      questionData: questions[3],
      elementType: ElementType.Textfield,
    },
  ];

  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='center'>
        Identificación
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
      {(!isNaN(lastSectionIdNumber) || lastSectionIdNumber > 0) && (
        <Link component='button' onClick={handleLastSection}>
          Continuar en la secction {lastSectionIdNumber}
        </Link>
      )}
    </div>
  );
};

export default Step1;
